import React from 'react';
import { RemoteComponentLoader as BaseRemoteComponentLoader } from '@honeybook/mfe-loader-web';
import type { RemoteAppData } from '~/types';
import RouterLoader from '~/RouterLoader';
import { initRemoteApp, initRemoteAppWithManifestData } from '~/initRemoteApp';

interface RemoteComponentLoaderProps {
    appData: RemoteAppData;
    fallback?: React.ReactNode;
}

function RemoteComponentLoader({
    appData,
    fallback
}: RemoteComponentLoaderProps) {
    return (
        <BaseRemoteComponentLoader
            appData={appData}
            fallback={fallback}
            loadingIndicator={<RouterLoader />}
            onInit={() => initRemoteApp(appData)}
            onLoaded={({ buildVersion }) =>
                initRemoteAppWithManifestData({ appData, buildVersion })
            }
        />
    );
}

export default RemoteComponentLoader;
